import React from "react";
import styles from './ProjectTags.module.css';
import Tag from "./Tag";
import Project from "../types/Project";
import { distinct } from "../common/collection-utils";

interface ProjectTagProps {
    project: Project,
    onClickClose?: (projectId: string) => void;
}

const ProjectTag = ({project, onClickClose}: ProjectTagProps) => {
    return <Tag className={styles.tag} value={`${project.id}`} onClickClose={onClickClose}>
        <a className={styles.jobLabel} href={project.qualityUri} target="_blank">
            <span className={styles.jobNumber}>{project.number}</span>
            <span className={styles.jobName}>{project.name}</span>
        </a>
    </Tag>
}

interface ProjectTagsProps {
    filedProjects: Project[],
    unfileEmailsFromProject: (projectId: string) => void
}

const ProjectTags = ({filedProjects, unfileEmailsFromProject}: ProjectTagsProps) => {
    const uniqueProjects = distinct(filedProjects, p => p.id);

    const tags = uniqueProjects.map(
        p =>  <ProjectTag key={p.id} project={p} onClickClose={unfileEmailsFromProject}/>
    )

    return <div>
        <div className={styles.container}>
            {tags}
        </div>
    </div>
}

export default ProjectTags;